/**
 * Seeded fixtures: named starting positions every test, script and UI story
 * can reach without a setup ritual. `pnpm fixtures` writes the JSON snapshots
 * in test/fixtures/ that the determinism test compares against.
 */
import { legalCommands } from './legal.js';
import { apply, decisionMaker } from './reducer.js';
import { nextInt } from './rng.js';
import { newGame } from './setup.js';
import { seedRng } from './rng.js';
export const FIXTURE_SEEDS = {
    twoPlayer: 'fixture-2p-0001',
    threePlayer: 'fixture-3p-0001',
    fourPlayer: 'fixture-4p-0001',
};
export function fixtureNewGame(playerCount) {
    const seed = playerCount === 2
        ? FIXTURE_SEEDS.twoPlayer
        : playerCount === 3
            ? FIXTURE_SEEDS.threePlayer
            : FIXTURE_SEEDS.fourPlayer;
    return newGame({ seed, playerCount });
}
/**
 * Drive a game forward with uniformly random legal commands. Stops after
 * `maxCommands`, when no command is legal, or when the engine reports
 * NOT_IMPLEMENTED (the walking skeleton's honest boundary).
 *
 * `events` is everything the run emitted, in order — what a room's log would
 * hold had the game been played for real, which is what the client's log panel
 * is fed from in demo mode.
 */
export function randomPlayout(start, botSeed, maxCommands) {
    let state = start;
    let rng = seedRng(botSeed);
    const events = [];
    for (let i = 0; i < maxCommands; i++) {
        if (state.phase.kind === 'gameOver')
            return { state, commands: i, events, stoppedBy: 'gameOver' };
        const actor = decisionMaker(state);
        if (actor === null)
            return { state, commands: i, events, stoppedBy: 'noMoves' };
        const options = legalCommands(state, actor);
        if (options.length === 0)
            return { state, commands: i, events, stoppedBy: 'noMoves' };
        let pick;
        [pick, rng] = nextInt(rng, options.length);
        const result = apply(state, options[pick], actor);
        if (!result.ok) {
            if (result.error.code === 'NOT_IMPLEMENTED')
                return { state, commands: i, events, stoppedBy: 'notImplemented' };
            throw new Error(`legalCommands offered a command apply rejected: ${result.error.message}`);
        }
        events.push(...result.events);
        state = result.state;
    }
    return { state, commands: maxCommands, events, stoppedBy: 'limit' };
}
//# sourceMappingURL=fixtures.js.map